import { ErrorService } from '../../../../../shared/services/error.service';
import { SearchForm } from './search-form.model';
import { Component, Output, EventEmitter, ViewChild, AfterViewChecked } from '@angular/core';
import { NgForm, ControlContainer } from '@angular/forms';
import { ScrollToService } from '../../../../../shared';


@Component({
    selector: 'jhi-search-form',
    templateUrl: './search-form.component.html',
    styleUrls: [
        'search-form.component.scss'
    ],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class SearchFormComponent implements AfterViewChecked {

    searchForm: SearchForm;
    enableScroll: boolean;

    @Output() onSearch = new EventEmitter;

    @ViewChild('form') form: NgForm;

    displaySearchForm = false;

    constructor(private errorService: ErrorService, private scrollToService: ScrollToService) {
        this.searchForm = new SearchForm();
    }

    ngAfterViewChecked(): void {
        if (this.form && this.form.submitted && !this.form.valid && this.enableScroll
        ) {
            this.scrollToService.scrollToFirstError();
            this.enableScroll = false;
        }
    }

    search() {
        if (!this.form.valid) {
            this.errorService.markAllControlsAsTouched(this.form);
            this.enableScroll = true;
        } else {
            this.onSearch.emit(this.searchForm);
        }
    }

    reset() {
        this.form.reset();
        this.onSearch.emit(null);
    }

    addNewRequerant() {
        this.displaySearchForm = true;
    }

    close() {
        this.displaySearchForm = false;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/search-form/search-form.component.ts